<template>
  <div class="col-md-6" v-if="card.stripe_object">
    <cards class="cards-card">
      <div class="wrapper-card-Item">
        <div class="box card-icon">
          <el-image
            :src="getHelpers.getCardBrandIcon(card.stripe_object)"
          >
          </el-image>
        </div>
        <div class="box details">
          <p class="name" style="color:red">{{ card.cardholder_name }}</p>
          <p>
            {{ getHelpers.getCardNumberWithStars(card.stripe_object.last4) }}
          </p>
          <h6>{{textExpiredCard(card.stripe_object)}}</h6>
          <p class="small">
            {{ card.stripe_object.exp_month }} /
            {{ card.stripe_object.exp_year }}
          </p>
        </div>
        <div class="box remove text-center my-auto">
          <div class="btn-group-vertical remove">
            <n-button
              type="danger"
              link
              icon
              round
              @click="removeCard(card.id)"
            >
              <i class="k-icon-trash"></i>
            </n-button>
          </div>
        </div>
      </div>
    </cards>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { Button, Cards } from "@/components";
import { helpers } from "@/utilities";
export default {
  name:'card-item',
  components: {
    [Button.name]: Button,
    Cards,
  },
  data() {
    return {
      getHelpers: helpers,
    };
  },
  computed: {
    ...mapState({
      userCards: (state) => state.userCards,
      user: (state) => state.auth.user,
    }),
    textExpiredCard(){
      return cardDetails => {
        return this.isCardExpired(cardDetails) ? this.$t('text.expired_on',{ month_year : '' }) 
        : this.$t('text.expires_on',{ month_year : ''})
      }
    },
  },
  methods: {
    ...mapActions(["deleteUserCardRequest"]),
    removeCard(idCard) {
      //--- show confirmation before deleting an address
      let message = this.$t("message.resource_delete_message_confirmation", {resource_name : "card"}) 
      let self = this;
      let options = {
        html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        okText: this.$t("button.confirm"),
        cancelText: this.$t('button.cancel'),
        animation: "fade", // Available: "zoom", "bounce", "fade"
        type: "basic", // coming soon: 'soft', 'hard'
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
      };
      this.$dialog.confirm(message, options).then(function() {
        self
          .deleteUserCardRequest(idCard)
          .then((response) => {
            if (response && response.error) {
                  helpers.showErrorMessageAlert(
                  helpers.getMessageFromAPIError(response)
                );
                return;
            }
            self.$notify({
              group: "topRight",
              title: this.$t("message.resource_removed_notify_title", {resource_name : 'Card'}),
              type: "warn",
              text: this.$t("message.resource_removed_notify_message", {resource_name : 'Card'}),
            });
          })
          .catch((e) => {
            this.captureException(e)
            //---- show Notification with error
            self.$notify({
              group: "topRight",
              title: this.$t("message.resource_removed_notify_title", {resource_name : 'Card'}),
              type: "danger",
              text: this.$t("message.resource_error_remove_notify_message", {resource_name : 'Card'}),
            });
          });
      });
    },
    isCardExpired(cardDetails){
      if(!cardDetails) {return true}
      let expiration = this.$moment(`${cardDetails.exp_month}/${cardDetails.exp_year}`, "MM/YYYY");
      let now = this.$moment();
      return !now.isSameOrBefore(expiration, 'month');
    }
  },
  props: {
    card: Object,
    small: Boolean,
  },
};
</script>
